import React, { useState } from "react";
import { Form, Input, Select } from "antd";
import FormModal from "../../../components/FormModal";
import PasswordFields from "../../../components/PasswordFields";
import { addUser } from "./SkeyeingestUsersAPI";
import { extractMsg } from "../../../utils/errorUtils";

const ROLE_OPTIONS = [
  { label: "Admin", value: "admin" },
  { label: "Guest", value: "guest" },
  { label: "Creator", value: "creator" },
  { label: "Manager", value: "manager" },
];

const GROUP_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Dev", value: "dev" },
  { label: "Test", value: "test" },
];

export default function SkeyeingestAddUserDialog({
  open,
  onClose,
  onSuccess,
  messageApi,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await addUser(values);
      messageApi.success("User successfully added.");
      form.resetFields();
      onSuccess();
      onClose();
    } catch (error) {
      messageApi.error({
        content: extractMsg(error, "Failed to add user"),
        key: "add-user-error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormModal
      title="Add Skeyeingest User"
      open={open}
      onClose={onClose}
      onFinish={handleFinish}
      loading={loading}
      form={form}
    >
      <Form.Item name="userId" label="User ID" rules={[{ required: true }]}>
        <Input placeholder="Enter User ID" />
      </Form.Item>
      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true, type: "email" }]}
      >
        <Input type="email" placeholder="Enter Email" />
      </Form.Item>
      <PasswordFields />
      <Form.Item
        name="roles"
        label="Roles"
        rules={[{ required: true, message: "Select at least one role" }]}
      >
        <Select
          mode="multiple"
          options={ROLE_OPTIONS}
          placeholder="Select Roles"
        />
      </Form.Item>
      <Form.Item
        name="groups"
        label="Groups"
        rules={[{ required: true, message: "Select at least one group" }]}
      >
        <Select
          mode="multiple"
          options={GROUP_OPTIONS}
          placeholder="Select Groups"
        />
      </Form.Item>
    </FormModal>
  );
}
